(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR.Agreement",
                {
                    url: "/Agreement/:workflow?envelopeId",
                    component: "agreement",
                    PageTitle: "Master Advisor Agreement",
                    //requiredPermissions: "NewAccountWizard:View",
                    params: {
                        workflow: null,
                        envelopeId: null
                    },
                    resolve: {                    
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                if (agreement.data === "")
                                    return null;
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {                       
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        rorSteps: ["masterAdvisorAgreementRequiredRecord", "userOnbordingRecord", "userMasterAdvisorAgreement", function (masterAdvisorAgreementRequiredRecord, userOnbordingRecord, userMasterAdvisorAgreement) {
                            var steps = [];

                            if (userOnbordingRecord !== null) {
                                if (masterAdvisorAgreementRequiredRecord !== null)
                                    steps.push({
                                        step: "agreement",
                                        description: "Sign Master Advisor Agreement",
                                        complete: userMasterAdvisorAgreement !== null ? true : false
                                    });

                                steps.push({
                                    step: "validate",
                                    description: "Validate your Personal Information",
                                    complete: userOnbordingRecord.InfoValidated !== null ? true : false
                                });

                                steps.push({
                                    step: "getcontracted",
                                    description: "Get Contracted!",
                                    complete: false
                                });
                            }                          
                            return steps;
                        }]
                    }
                });
        }
    ]);

    app.component("agreement",
        {
            templateUrl: "App/RORWizard/Agreement/agreement.html",
            controller: agreementCtrl,
            bindings: {
                masterAdvisorAgreementRequiredRecord: "<",
                userMasterAdvisorAgreement: "<",
                rorSteps: "<"
            }
        });

    agreementCtrl.$inject = ["$http", "permissionService", "agreementsApi", "$window", "$location", "$state", "$q", "$stateParams", "onboardingApi"];

    function agreementCtrl($http, permissionService, agreementsApi, $window, $location, $state, $q, $stateParams, onboardingApi) {
        var $ctrl = this;
        window.a = this;
        function init() {

            $ctrl.UI = {
                docIsigned: $ctrl.userMasterAdvisorAgreement === null ? false : true,
                loading: true
            };
        
            $ctrl.envelopeId = $stateParams.envelopeId;
            $ctrl.workflow = $stateParams.workflow === null ? "" : $stateParams.workflow;

            //when returning from docusign below
            if ($ctrl.userMasterAdvisorAgreement === null &&
                $ctrl.envelopeId !== null &&
                $location.search().event === "signing_complete") {


                var envelopeData = { DocusignEnvelopeId: $ctrl.envelopeId };
                agreementsApi.createMasterAdvisorAgreement(envelopeData).then(function(result) {
                    $ctrl.UI.docIsigned = true;                   
                    $ctrl.UI.loading = false;
                });
            } else {
                $ctrl.UI.loading = false;
            }
        }

        $ctrl.createAgreement = function () {
            $ctrl.redirecting = true;

            agreementsApi.initMasterAdvisorAgreement($ctrl.workflow).then(function (result) {
                    console.log(result);
                    $window.location.href = result;
                },
                function error(x) {
                    console.log(x);
                    $ctrl.signError = true;
                    $ctrl.redirecting = false;
                });
        }; 

        $ctrl.tempOptOut = function () {
            permissionService.setOptOutMasterAdvisorAgreement();
        };


        /*$ctrl.downloadPdfByArcAgentId = function(arcAgentId) {
            agreementsApi.getgetMasterAdvisorAgreementPdfByArcAgentId(arcAgentId).then(function(pdf) {
                console.log(pdf);
                var fUrl = $window.URL.createObjectURL(pdf);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function() {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        };

        $ctrl.downloadPdf = function(agreement) {

            agreementsApi.getgetMasterAdvisorAgreementPdf(agreement.Id).then(function(pdf) {
                console.log(pdf);
                var fUrl = $window.URL.createObjectURL(pdf);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function() {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        };

        $ctrl.downloadXml = function(agreement) {

            agreementsApi.getgetMasterAdvisorAgreementXml(agreement.Id).then(function(xml) {
                console.log(xml);
                var fUrl = $window.URL.createObjectURL(xml);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function() {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        };*/
        
        init();

    }
})(window.app, window.angular); // jshint ignore:line